// extracted by mini-css-extract-plugin
export default {"melodyVideo":"AJ-z","isFullWidth":"BJ-z","landingPageVideo":"CJ-z","play":"DJ-z","iframeVideo":"EJ-z","playHidden":"FJ-z","fullwidth":"GJ-z"};